module.exports = __webpack_public_path__ + "static/img/45.cb8739e6.gif";